<template>
  <div class="main-content main-content_vertical">
    <div class="wrapper generation-wrapper">

      <div class="h1 h1-mob-lg">
        {{ $t('generation.page_header') }}
      </div>
      <div class="text-warn warn-block" v-if="$store.getters.generationDisabledGlobally">
        {{ $t('generation.generation_disabled_globally') }}
      </div>

      <div v-if="effectGenerationSessionChecked && !$store.getters.attemptSelectedBySponsor" class="attempt-selector h2 h2-mob-lg">
        {{ $t('generation.attempt') }}
        <button @click="prevAttempt" :disabled="!canNavigateLeft" class="attempt-selector-button h2 h2-mob-lg"> &lt; </button>
        {{ currentAttemptIndex + 1 }}/{{ maxGenerationAttempts }}
        <button @click="nextAttempt" :disabled="!canNavigateRight" class="attempt-selector-button h2 h2-mob-lg"> &gt; </button>
      </div>

      <div class="h2 h2-mob-lg" v-if="!effectGenerationSessionChecked">
        {{ $t('generation.loading_please_wait') }}
      </div>
      <div v-else-if="newAttemptSelected">
        <StylePresetSelector />
        <div class="h2 h2-mob-lg prompt-header">{{ $t('generation.enter_text_to_create_sticker') }}:</div>
        <text-input :disabled="!promptInputAvailable" v-model="currentPrompt" :maxlength="300" :placeholder="$t('generation.enter_text_here')" :bottomText="bottomText" :highLightBottomText="$store.getters.errorMessage !== ''"/>

        <button class="btn-orange" :disabled="!canCreate" @click="$store.dispatch('generateSticker', currentPrompt)">
          {{ $t('generation.create_button') }}
        </button>
      </div>

      <div v-else-if="!$store.getters.attemptSelectedBySponsor" class="attempt-details">
        <div class="attempt-image">
          <img :src="generatedImageURL" alt="Generated Image"  v-if="generatedImageURL"/>
          <p class="orange" v-else-if="effectGenerationError">{{ $t('generation.an_error_occurred_while_creating_the_sticker') }}</p>
          <p class="orange" v-else-if="bannedWordsFound">{{ $t('generation.banned_words_found') }}</p>
          <p class="orange" v-else-if="unrecognizedError">{{ $t('generation.an_unrecognized_error_occurred_while_creating_the_sticker') }}</p>
          <p class="orange" v-else>{{ $t('generation.image_not_available_try_to_reload_page') }}</p>
        </div>
        <div class="attempt-info">
          <div class="h2 h2-mob-lg" v-if="stylePresetName">{{ $t('generation.style') }}:</div>
          <div class="style-preset" v-if="stylePresetName">{{ stylePresetName }}</div>
          <div class="h2 h2-mob-lg">{{ $t('generation.text_for_creation') }}:</div>
          <div class="prompt">{{ srcPrompt }}</div>
          <div v-if="!stickerHasBeenSent">
            <div class="attempt-info-text" v-if="canSent">
                {{ $t('generation.you_can_select_this_sticker_and_send_it_to_the_stream_right_now') }}
                <span v-if="nameAllowed && textAllowed">{{ $t('generation.on_the_next_step_you_can_enter_your_name_and_message_text_if_you_wish') }}</span>
                <span v-else-if="nameAllowed">{{ $t('generation.on_the_next_step_you_can_enter_your_name_if_you_wish') }}</span>
                <span v-else-if="textAllowed">{{ $t('generation.on_the_next_step_you_can_enter_your_message_text_if_you_wish') }}</span>
            </div>
            <div class="attempt-info-text highlight-text" v-else>
              {{ $store.getters.errorMessage ? $store.getters.errorMessage : $t('generation.this_attempt_to_create_a_sticker_failed_try_again')}}
            </div>
            <button class="btn-orange" @click="sendOrSelect" :disabled="!canSent">
              <span v-if="nameAllowed || textAllowed">{{ $t('generation.select_this_sticker') }}</span>
              <span v-else>{{ $t('generation.send_this_sticker') }}</span>
            </button>
            <button class="btn-orange" v-if="hasUnspentAttempt && !$store.getters.generationDisabledGlobally" @click="unspentAttempt">
              {{ $t('generation.create_new_sticker') }}
            </button>
          </div>
        </div>
      </div>

      <div v-else>
        <name-input :disabled="$store.getters.effectPostInProgress" v-if="nameAllowed" v-model="name" :maxlength="$store.getters.visuals.maxNameLength" />
        <text-input :disabled="$store.getters.effectPostInProgress" v-if="textAllowed" v-model="text" :maxlength="$store.getters.visuals.maxTextLength" :placeholder="$t('forms.your_message')"/>
        <div class="btns">
          <button class="btn-orange secondary" @click="$store.commit('cancelSelection')">
            {{ $t('generation.back_to_creation') }}
          </button>
          <button class="btn-orange" @click="sendGeneratedEffect" :disabled="!canSent">
            {{ $t('generation.send_this_sticker') }}
          </button>
        </div>
      </div>

      <div class="btns">
        <router-link to="/" class="orange-link">{{ $t('crypto_payment.go_back') }}</router-link>
        <a class="orange-link text-warn" @click="sendDonationWithoutSendingGeneratedEffect" :disabled="this.$store.getters.effectPostInProgress">
          {{ $t('generation.send_donation_without_sticker') }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>

import StylePresetSelector from "@/components/EffectGeneration/StylePresetSelector.vue";
import TextInput from "@/components/general/TextInput/index";
import {EffectGenerationAttemptStatus} from "@/store/models/EffectGenerationAttempt";
import NameInput from "components/general/NameInput/index.vue";

export default {
  name: "EffectGeneration",
  data() {
    return {
      currentPrompt: '',
      name: '',
      text: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.$store.getters.visuals?.effectGenerationEnabled || !to.query.session) {
        next('/');
      } else {
        vm.$store.dispatch('checkEffectGenerationSession', to.query.session);
        next();
      }
    });
  },
  watch: {
    effectGenerationSessionChecked() {
      if (this.effectGenerationSessionChecked && !this.$store.getters.effectGenerationSession) {
        this.$router.push('/');
      }
    },
  },
  components: {
    NameInput,
    StylePresetSelector,
    TextInput,
  },
  computed: {
    bottomText() {
      if (this.$store.getters.errorMessage) {
        return this.$store.getters.errorMessage;
      }
      if (this.$store.getters.generationInProgress) {
        return this.$t('generation.creation_in_progress');
      }
      return null;
    },
    nameAllowed() {
      return this.$store.getters.nameAllowedInGeneration;
    },
    textAllowed() {
      return this.$store.getters.textAllowedInGeneration;
    },
    effectGenerationSessionChecked() {
      return this.$store.getters.effectGenerationSessionChecked;
    },
    newAttemptSelected() {
      return this.$store.getters.newAttemptSelected;
    },
    effectGenerationError() {
      return this.$store.getters.currentAttemptStatus === EffectGenerationAttemptStatus.EffectGenerationError;
    },
    bannedWordsFound() {
      return this.$store.getters.currentAttemptStatus === EffectGenerationAttemptStatus.BannedWordsFound;
    },
    unrecognizedError() {
      return this.$store.getters.currentAttemptStatus === EffectGenerationAttemptStatus.UnrecognizedError;
    },
    canCreate() {
      return this.currentPrompt.length > 0 && this.newAttemptSelected && !this.$store.getters.generationInProgress && !this.$store.getters.generationDisabledGlobally;
    },
    canSent() {
      return (this.$store.getters.currentAttemptStatus === EffectGenerationAttemptStatus.EffectGenerated || this.$store.getters.currentAttemptStatus === EffectGenerationAttemptStatus.EffectSelectedBySponsor) && !this.$store.getters.effectPostInProgress;
    },
    hasUnspentAttempt() {
      return this.$store.getters.effectGenerationSession?.attempts[this.$store.getters.effectGenerationSession.attempts.length - 1]?.status === EffectGenerationAttemptStatus.Created;
    },
    stickerHasBeenSent() {
      let haveSent = false;
      this.$store.getters.effectGenerationSession?.attempts.forEach(attempt => {
        if (attempt.status === EffectGenerationAttemptStatus.EffectSent) {
          haveSent = true;
        }
      });
      return haveSent;
    },
    availableStylePresets() {
      return this.$store.getters.availableEffectGenerationStylePresets || [];
    },
    promptInputAvailable() {
      return !this.$store.getters.generationInProgress && !this.$store.getters.generationDisabledGlobally;
    },
    maxGenerationAttempts() {
      return this.$store.getters.maxGenerationAttempts;
    },
    currentAttemptIndex: {
      get() {
        return this.$store.getters.selectedAttemptIndex;
      },
      set(value) {
        this.$store.commit('setCurrentAttemptIndex', value);
      }
    },
    canNavigateLeft() {
      return this.currentAttemptIndex > 0 && !this.$store.getters.generationInProgress;
    },
    canNavigateRight() {
      return this.currentAttemptIndex < this.maxGenerationAttempts - 1 && !this.newAttemptSelected && !this.$store.getters.generationInProgress;
    },
    generatedImageURL() {
      return this.$store.getters.effectGenerationSession?.attempts[this.currentAttemptIndex]?.generatedImageURL;
    },
    srcPrompt() {
      return this.$store.getters.effectGenerationSession?.attempts[this.currentAttemptIndex]?.prompt;
    },
    stylePresetName() {
      const preset = this.availableStylePresets.find(preset => preset.ID === this.$store.getters.effectGenerationSession?.attempts[this.currentAttemptIndex]?.stylePresetID);
      if(!preset) {
        return '';
      }
      return this.$t(`generation.styles.${preset.style.replace(/-/g, '_').replace('3d', 'three_d')}`);
    },
  },
  methods: {
    prevAttempt() {
      if (this.canNavigateLeft) {
        this.currentAttemptIndex--;
      }
    },
    nextAttempt() {
      if (this.canNavigateRight) {
        this.currentAttemptIndex++;
      }
    },
    unspentAttempt() {
      this.currentAttemptIndex = this.$store.getters.effectGenerationSession.attempts.length - 1;
    },
    sendOrSelect() {
      if (this.nameAllowed || this.textAllowed) {
        this.$store.commit('selectAttempt');
      } else {
        this.sendGeneratedEffect();
      }
    },
    sendGeneratedEffect() {
      this.$store.dispatch('sendGeneratedEffect', {
        name: this.name || undefined,
        text: this.text || undefined,
      });
    },
    sendDonationWithoutSendingGeneratedEffect() {
      this.$store.dispatch('sendGeneratedEffect', {
        name: this.name || undefined,
        text: this.text || undefined,
        sendDonation: true,
      });
    },
  },
};
</script>
<style lang="scss">
.btns {
  display: flex !important;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
  max-width: 100%;
  @media (max-width: 849px) {
    flex-direction: column;
    align-items: center;
    a {
      margin-top: 20px;
      text-align: center;
    }
  }
}
.text-warn {
  color: red !important;
}
.btn-orange {
  margin-bottom: 20px;
  cursor: pointer;
  width: 100%;
}
.attempt-selector {
  display: flex;
  justify-content: left;
  align-items: center;
  button {
    margin: 0 10px;
    border: 2px solid var(--control-color);
    color: var(--background-color) !important;
    background-color: var(--control-color);
    width: 32px;
    &:disabled {
      background-color: var(--inactive-color);
      border-color: var(--inactive-color);
    }
  }
  margin-bottom: 10px;
  padding-bottom: 5px;
  min-width: 100% !important;
  border-bottom: 1px solid var(--foreground-color);
}
.attempt-details {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 20px;
  .attempt-info-text {
    margin-bottom: 20px;
    font-size: 14px;
  }
}

.attempt-image {
  flex: 1 1 100%;
  max-width: 512px;
  margin-bottom: 20px;

  img {
    max-width: 100%;
    height: auto;
    border: 2px solid var(--foreground-color);
  }
}

.attempt-info {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: calc(100% - 532px);

  @media (max-width: 768px) {
    max-width: 100%;
  }

  .style-preset,
  .prompt {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid var(--foreground-color);
    font-size: 14px;
  }
  .style-preset {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (min-width: 850px) {
  .generation-wrapper {
    padding: 0 40px !important;
  }
}

.generation-wrapper {
  padding-bottom: 280px !important;
  max-width: 850px !important;
}

@media (max-width: 849px) {
  .attempt-details {
    flex-direction: column;
    align-items: center;
  }

  .attempt-info {
    max-width: 100%;
  }
  .generation-wrapper {
    padding: 0 20px !important;
    padding-bottom: 280px !important;
    max-width: 552px !important;
  }
}

.prompt-header {
  margin-bottom: 10px;
  width: 100%;
  max-width: 100%;
}

.attempt-selector-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  line-height: normal;
}

.warn-block {
  margin-bottom: 8px;
  margin-top: -8px
}
</style>
